import List from '@mui/material/List';
import { NavItemType } from '../type';
import { SidebarContext } from '../context';
import SidebarNavItem from './SidebarNavItem/SidebarNavItem';
import SidebarNavItemCollapse from './SidebarNavItemCollapse';
import Typography from '@mui/material/Typography';
import { useContext } from 'react';

interface NavGroupProps {
  item: NavItemType;
}

const SidebarNavGroup = ({ item }: NavGroupProps) => {
  const { sidebarOpen } = useContext(SidebarContext);
  const items = item.children?.map((menu) => {
    switch (menu?.type) {
      case 'collapse':
        return menu.disabled ? null : <SidebarNavItemCollapse key={menu.id} menu={menu} level={1} parentId={item.id!} />;
      case 'item':
        return menu.disabled ? null : <SidebarNavItem key={menu.id} item={menu} level={1} />;
      default:
        return (
          <Typography key={menu?.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return (
    <>
      <List role="menubar" disablePadding={!sidebarOpen}>
        {item.title && (
          <Typography variant="caption" display="block" gutterBottom>
            {item.title}
            {item.caption && (
              <Typography variant="caption" display="block" gutterBottom>
                {item.caption}
              </Typography>
            )}
          </Typography>
        )}

        {items}
      </List>
    </>
  );
};

export default SidebarNavGroup;
